import {Component, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

export const LANGUAGES = {
  en: 'English',
  es: 'Espanõl',
  vi: 'Tiếng Việt',
  ko: '한국어',
  'zh-TW': '繁体',
  'zh-CN': '简体',
};

@Component({
  selector: 'language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.scss'],
})
export class LanguageDropdownComponent {
  @Input() disabled = false;
  languages = LANGUAGES;
  constructor(public translate: TranslateService) {}

  public onChange(value) {
    this.translate.use(value);
    localStorage.setItem('lang', value);
  }
}
